import './countries'

export const animationFadeInUp =
  'delay-[300ms] duration-[600ms] taos:translate-y-[200px] taos:opacity-0'
export const animationOffset = 20

export function GetDelayTreeTiles(n) {
  return `md:delay-[${((n % 3) + 1) * 200}ms]`
}

export function GetDelayTwoTiles(n) {
  return `md:delay-[${((n % 2) + 1) * 200}ms]`
}
